module.exports = __webpack_public_path__ + "img/9788956243535.0f7bb9c6.jpg";